import {ChiliCommentsNoCaptcha} from '../../nocaptcha/src/index';
import {ChiliCommentsReCaptcha} from '../../recaptcha/src/index';
import {ChiliCommentsBitrixCaptcha} from '../../bitrix_captcha/src/index';
import {ChiliCommentsYandexCaptcha} from '../../yandex_captcha/src/index';

BX.namespace("BX.Chili.Comments.Captcha");

/**
 * @param {Object} options
 * @param {'no-captcha'|'bitrix-captcha'|'yandex-smart-captcha'|'recaptcha'} options.type
 * @param  {string} options.publicKey
 * @param  {boolean} options.invisible
 * */
BX.Chili.Comments.Captcha = function (options){

    let variants = new Map([
        ['no-captcha', ChiliCommentsNoCaptcha],
        ['bitrix-captcha', ChiliCommentsBitrixCaptcha],
        ['yandex-smart-captcha', ChiliCommentsYandexCaptcha],
        ['recaptcha', ChiliCommentsReCaptcha],
    ]);

    let constructor = variants.get(options.type);

    if(!constructor){
        constructor = ChiliCommentsNoCaptcha;
    }

    this.instance = constructor(options);

    this.addEventListener = (event, listener) => {
        this.instance.addEventListener(event, listener);
    }

    /**@param {HTMLElement} form*/
    this.render = (form) => {
        this.instance.render(form);
    };

    /**@param {HTMLElement} form*/
    this.check = (form) => {
        return this.instance.check(form);
    }

    this.setPublicKey = (publicKey) => {
        this.instance.setPublicKey(publicKey);
    }

    /**
     * Метод показывает, является ли капча "Зависимой". Проверка зависимой капчи происходит по событию submit формы.
     * Независимую капчу можно пройти до отправки формы
     *
     * @return boolean
     * */
    this.isDependedCaptcha = () => {
        return this.instance.isDependedCaptcha();
    }

}
